@if (node?.data) {
<div class="group-cell portal-clickable ">
  @if(allowExpandAll) {
  <button (click)="toggleExpandAll()"
          [matTooltip]="(node?.expanded ? 'shared.tooltips.collapseAll' : 'shared.tooltips.expandAll') | translate"
          matTooltipClass="mat-tooltip-multiline"
          matTooltipPosition="below"
          class="expand-all-button al-tile-button btn-small">
    <fa-icon [icon]="['fas', (node?.expanded ? 'caret-down': 'forward')]"
             class="btn-icon"
             [class.expanded]="node?.expanded" />
  </button>
  }
  @if (icon) {
  <div class="group-icon-container"
       (click)="toggleExpand()">
    <fa-icon [icon]="icon"
             class="group-icon" />
  </div>
  }
  <div class="group-details"
       (click)="toggleExpand()">
    <p class="group-title"
       [matTooltip]="tooltip"
       matTooltipClass="mat-tooltip-multiline"
       matTooltipPosition="right">{{node?.data?.label}}</p>
    @if (budget) {
    <div [matTooltip]="remainingHoursTooltip"
         matTooltipClass="mat-tooltip-multiline"
         matTooltipPosition="right">
      <p>{{ hoursToPlan | formatNumber}}h</p>
    </div>
    }
  </div>
</div>
} @else {
<div class="group-cell group-skeleton">
  <div class="group-icon-container">
    <div class="sk-line group-icon"></div>
  </div>
  <div class="class-details skeleton">
    <div class="sk-line group-title"></div>
  </div>
</div>
}